<template>
	<h2
		v-if="!isMobile && !store.isLandingPage"
		id="loginRegisterModalHeadlineId"
		tabindex="-1"
		class="m-0 mb-6 text-[2rem] font-semibold leading-[2.714285714rem]"
	>
		{{ $t(store.isLogin ? "login.headline" : "registration.headline") }}
	</h2>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";
const { isMobile } = useIsMobile();
import { $t } from "@/main";
</script>
